import React from "react"
import s from "./HomeFeature.module.scss"
import cx from "classnames"

export default function HomeFeature({
  img,
  alt,
  cta,
  link,
  children,
  gtmClass,
}) {
  return (
    <div className={s.homeFeature}>
      <img class={s.img} src={img} alt={alt} />
      <div className={s.content}>
        {children}
        <div className={s.row}>
          <a
            href={link}
            className={cx(s.button, "button", gtmClass)}
            target="_blank"
            rel="noreferrer"
          >
            {cta}
          </a>
        </div>
      </div>
    </div>
  )
}
